<div class="local-authorization-list">
  <mat-chip-set class="local-authorization-actions" aria-label="Local authorization list actions">
    <mat-chip
      class="action-chip"
      [class.action-chip-enabled]="localAuthorizationList?.enabled"
      [class.action-chip-disabled]="!localAuthorizationList?.enabled"
      [disabled]="pending"
      (click)="requestToggleEnabled()">
      <mat-icon>{{ localAuthorizationList?.enabled ? 'toggle_on' : 'toggle_off' }}</mat-icon>
      {{ localAuthorizationList?.enabled ? 'Enabled' : 'Disabled' }}
    </mat-chip>

    <mat-chip
      class="action-chip action-chip-sync"
      [class.action-chip-sync-pending]="!localAuthorizationList?.synchronizationDone"
      [class.action-chip-sync-done]="localAuthorizationList?.synchronizationDone"
      [disabled]="pending || !localAuthorizationList?.enabled || localAuthorizationList?.synchronizationDone"
      (click)="requestSynchronization()">
      <mat-icon>sync</mat-icon>
      Synchronize
    </mat-chip>
  </mat-chip-set>

  <div class="identifiers-panel">
    <div class="identifiers-panel-header">
      <span class="identifiers-panel-title">Identifiers</span>
      <span class="identifiers-panel-count" *ngIf="localAuthorizationList?.identifiers?.length">
        {{ localAuthorizationList?.identifiers?.length }}
      </span>
    </div>

    <div class="add-identifier-field">
      <input
        class="identifier-input-native"
        type="text"
        placeholder="Add identifier…"
        [(ngModel)]="newIdentifier"
        [disabled]="pending"
        (keyup.enter)="addIdentifier()"
      />
      <button
        mat-icon-button
        type="button"
        class="add-identifier-button"
        matTooltip="Add identifier"
        [disabled]="pending || !newIdentifier.trim()"
        (click)="addIdentifier()">
        <mat-icon>add</mat-icon>
      </button>
    </div>

    <mat-chip-set
      class="identifiers-chips"
      *ngIf="localAuthorizationList?.identifiers?.length; else emptyList">
      <mat-chip-row
        *ngFor="let identifier of localAuthorizationList?.identifiers"
        (removed)="removeIdentifier(identifier)">
        <span class="identifier-chip-text">{{ identifier }}</span>
        <button matChipRemove [attr.aria-label]="'Remove ' + identifier" [disabled]="pending">
          <mat-icon>close</mat-icon>
        </button>
      </mat-chip-row>
    </mat-chip-set>

    <ng-template #emptyList>
      <p class="empty-message">No identifiers configured.</p>
    </ng-template>
  </div>
</div>
